import React from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle, Mail, ExternalLink, HelpCircle } from 'lucide-react';

const ContactHelp = () => {
  return (
    <div className="min-h-screen bg-background pb-20 lg:pb-0">

      {/* Hero Banner */}
      <div className="bg-gradient-to-r from-[#054581] to-[#1086a4] text-white py-14 px-6 text-center">
        <div className="flex justify-center mb-4">
          <HelpCircle className="w-12 h-12 opacity-90" />
        </div>
        <h1 className="text-4xl font-bold mb-3">Contact & Help</h1>
        <p className="text-lg opacity-90 max-w-xl mx-auto">
          We're here to help. Reach out through any of the options below.
        </p>
      </div>

      <div className="max-w-3xl mx-auto px-6 py-10 space-y-6">
        <div className="bg-primary/10 border-l-4 border-primary rounded-lg p-5 flex gap-4">
          <MessageCircle className="w-6 h-6 text-primary shrink-0 mt-0.5" />
          <p className="text-foreground text-base leading-relaxed">
            <span className="font-semibold">Quick tip:</span> You can connect with your admin directly on the{' '}
            <Link to="/messages" className="underline font-semibold hover:text-[#1086a4] transition-colors">
              messaging system
            </Link>
            . Alternatively, send us a note with the form below.
          </p>
        </div>

        {/* Messaging Card */}
        <div className="bg-card rounded-xl shadow-sm border border-border p-6 flex flex-col sm:flex-row items-center gap-6">
          <div className="bg-primary/10 rounded-full p-4">
            <MessageCircle className="w-8 h-8 text-primary" />
          </div>
          <div className="flex-1 text-center sm:text-left">
            <h2 className="text-xl font-bold text-foreground mb-1">Message Your Admin</h2>
            <p className="text-foreground/50 text-sm">Get a fast response by messaging your admin directly inside the platform.</p>
          </div>
          <Link
            to="/messages"
            className="shrink-0 bg-[#1086a4] hover:bg-[#054581] text-white font-semibold py-3 px-7 rounded-lg transition-colors duration-200"
          >
            Open Messages
          </Link>
        </div>

        {/* Divider */}
        <div className="flex items-center gap-4">
          <div className="flex-1 h-px bg-border" />
          <span className="text-foreground/40 text-sm font-medium">or</span>
          <div className="flex-1 h-px bg-border" />
        </div>

        {/* Contact Form Card */}
        <div className="bg-card rounded-xl shadow-sm border border-border p-6 flex flex-col sm:flex-row items-center gap-6">
          <div className="bg-primary/10 rounded-full p-4">
            <Mail className="w-8 h-8 text-primary" />
          </div>
          <div className="flex-1 text-center sm:text-left">
            <h2 className="text-xl font-bold text-foreground mb-1">Send Us a Note</h2>
            <p className="text-foreground/50 text-sm">Fill out our contact form and we'll get back to you as soon as possible.</p>
          </div>
          <a
            href="https://forms.monday.com/forms/44dc9b9eca246b64466a6821c04fd96f?r=use1"
            target="_blank"
            rel="noopener noreferrer"
            className="shrink-0 flex items-center gap-2 bg-[#054581] hover:bg-[#1086a4] text-white font-semibold py-3 px-7 rounded-lg transition-colors duration-200"
          >
            Open Form
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>

      </div>
    </div>
  );
};

export default ContactHelp;
